invitations:
  toast:
    progress: Bitte warten …
    success: Einladung angenommen!
autoUpdate:
  ready: ShuttlerockCloud ist bereit für ein Update!
  updateNow: Jetzt aktualisieren
navigation:
  accountSettings: Kontoeinstellungen
  home: Startseite
  admin: Admin
  brands: Marken
  brandProfile: Markenprofil
  clients: Kunden
  contactUs: Kontakt
  newOrder: Neues Projekt
  preferences: Einstellungen
  profile: Profil
  projects: Projekte
  projectShortcuts:
    all: Alle
    draft: Entwurf
    active: Aktiv
    approved: Genehmigt
  creativeLibrary: Creative-Bibliothek
  signOut: Abmelden
  support: Hilfe-Center
  users: Benutzer
  accountInsights: Konto-Einblicke
preferences:
  title: Einstellungen
  theme:
    title: Design
    preset:
      title: Shuttlerock-Voreinstellung
      description: Seiten werden standardmäßig im hellen Modus angezeigt. Einige von Shuttlerock vordefinierte Seiten werden im dunklen Modus angezeigt.
    system:
      title: System folgen
      description: Seiten werden je nach Ihrer Betriebssystemeinstellung im hellen oder dunklen Modus angezeigt.
    light:
      title: Immer hell
      description: Alle Seiten werden immer im hellen Modus angezeigt.
    dark:
      title: Immer dunkel
      description: Alle Seiten werden immer im dunklen Modus angezeigt.
  language:
    label: Sprache auswählen
  privacy:
    title: Datenschutz
    essential:
      title: Erforderliche Dienste
      description: Erforderlich, damit Shuttlerock funktioniert. Dazu gehören die Anmeldung, der Schutz Ihres Kontos, das Speichern Ihrer Einstellungen und Fehlerberichte, mit denen wir Probleme beheben.
      status: Immer aktiv
    analytics:
      title: Produktanalyse
      description: Hilft uns zu verstehen, welche Funktionen genutzt werden, damit wir Shuttlerock verbessern können. Wir nutzen das nicht für Werbung.
      learnMore: Mehr erfahren
errorPage:
  default:
    title: Etwas ist schiefgelaufen
    defaultMessage: Bitte versuchen Sie es erneut oder wenden Sie sich an unser Support-Team, wenn Sie Hilfe bei der Lösung dieses Problems benötigen.
    button:
      primary: Erneut versuchen
      secondary: Support kontaktieren
creativeLibrary:
  error:
    conceptDetails: Konzeptdetails konnten nicht geladen werden
